import React from "react";
import { Building2, Code2, Smartphone } from "lucide-react";

function MediaIcon({ type }) {
  if (type === "mobile") return <Smartphone className="h-7 w-7" aria-hidden="true" />;
  if (type === "web") return <Code2 className="h-7 w-7" aria-hidden="true" />;
  return <Building2 className="h-7 w-7" aria-hidden="true" />;
}

export default function ProjectMediaPlaceholder({ project, compact = false }) {
  return (
    <div
      className={`relative flex h-full w-full items-center justify-center overflow-hidden bg-slate-950/70 text-center ${compact ? "p-6" : "p-8"}`}
      role="img"
      aria-label={`${project.title} project identity`}
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-cyan-500/40 to-transparent" />
      <div className="max-w-sm">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl border border-cyan-500/25 bg-cyan-500/10 text-cyan-300">
          <MediaIcon type={project.type} />
        </div>
        <p className="mt-5 text-xs font-semibold uppercase tracking-[0.16em] text-cyan-400">
          {project.type === "mobile" ? "Mobile product engineering" : "End-to-end product engineering"}
        </p>
        <p className="mt-2 text-lg font-bold text-slate-100 sm:text-xl">{project.title}</p>
        {project.eyebrow && <p className="mt-3 text-xs leading-5 text-slate-500">{project.eyebrow}</p>}
      </div>
    </div>
  );
}
